import React, {ReactNode} from 'react';

import {Trans} from '../../../../../libs/shared/helpers/src/internationalization/react';
import {FontFamilyPresetNamesEnum} from './fontFamilyHelpers';

type FontFamilyLabelMap = {[key in FontFamilyPresetNamesEnum]: ReactNode};

export const fontFamilyLabels: FontFamilyLabelMap = {
  [FontFamilyPresetNamesEnum.SANS_SERIF]: <Trans id="font-family-sansserif">Sans-Serif</Trans>,
  [FontFamilyPresetNamesEnum.SERIF]: <Trans id="font-family-serif">Serif</Trans>,
  [FontFamilyPresetNamesEnum.FIXED_WIDTH]: <Trans id="font-family-fixedwidth">Fixed width</Trans>,
  [FontFamilyPresetNamesEnum.WIDE]: <Trans id="font-family-wide">Wide</Trans>,
  [FontFamilyPresetNamesEnum.ARIAL]: <Trans id="font-family-arial">Arial</Trans>,
  [FontFamilyPresetNamesEnum.HELVETICA]: <Trans id="font-family-helvetica">Helvetica</Trans>,
  [FontFamilyPresetNamesEnum.TIMES_NEW_ROMAN]: (
    <Trans id="font-family-times-new-roman">Times New Roman</Trans>
  ),
  [FontFamilyPresetNamesEnum.CALIBRI]: <Trans id="font-family-calibri">Calibri</Trans>,
  [FontFamilyPresetNamesEnum.COURIER_NEW]: <Trans id="font-family-courier-new">Courier New</Trans>,
  [FontFamilyPresetNamesEnum.COMIC_SANS]: <Trans id="font-family-comicsans">Comic Sans</Trans>,
  [FontFamilyPresetNamesEnum.GEORGIA]: <Trans id="font-family-georgia">Georgia</Trans>,
  [FontFamilyPresetNamesEnum.TAHOMA]: <Trans id="font-family-tahoma">Tahoma</Trans>,
  [FontFamilyPresetNamesEnum.TREBUCHET]: <Trans id="font-family-trebuchet">Trebuchet</Trans>,
  [FontFamilyPresetNamesEnum.VERDANA]: <Trans id="font-family-verdana">Verdana</Trans>,
};
